export const assert: (value: unknown) => asserts value = (value) => {
    if (!value) {
        throw new Error('Asserted falsy value')
    }
}

export const assertNever = (value: never, description: string, valueForMessage?: string): Error => {
    return new Error('Unexpected ' + description + ': ' + (valueForMessage || value))
}
